import { TypeAsserter } from '@attain-apps/type-guards'

import * as core from '../../core'

export type Person = core.common.Identified<Person.Id> &
  core.common.Named &
  core.common.Coded &
  core.common.Described.Optionally & {
    firstName: string
    lastName: string
  }

export namespace Person {
  export type Id = core.dms.data.Record.Id
  export namespace Id {
    export const isId = core.dms.data.Record.Id.isId
    export const assertIsId: TypeAsserter<Id> = TypeAsserter.Factory.from(isId)
  }

  export type WithUserId = Person & {
    userId: string
  }
}
